import React from 'react';
import { replaceWithJioCDN } from '../../../../src/utils/imageHandling';

type Fn = () => void;
interface ImageProps {
  src: string;
  alt?: string;
  testId?: string;
  loading?: 'lazy' | 'auto' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
  decoding?: 'sync' | 'async' | 'auto';
  className?: string;
  handleError?: Fn;
  handleClick?: Fn;
  handleOnLoad?: Fn;
  imgStyle?: {};
  id?: string;
  LCP_image?: HTMLImageElement | null;
  roleForImage?:string;
  ariaHidden?:boolean;
  opensDialog?:boolean;
  isPdpHero?: boolean;
}

const Image: React.FC<ImageProps> = (props: ImageProps): JSX.Element => {
  const {
    LCP_image,
    src = '',
    alt = '',
    className = '',
    handleError,
    handleClick,
    loading,
    fetchPriority,
    decoding,
    handleOnLoad,
    testId = '',
    imgStyle = {},
    id = '',
    roleForImage = '',
    ariaHidden = false,
    opensDialog = false,
    isPdpHero = false
  } = props;


  if (LCP_image) {
    const lcpWidth = LCP_image.getAttribute ? LCP_image.getAttribute('width') : undefined;
    const lcpHeight = LCP_image.getAttribute ? LCP_image.getAttribute('height') : undefined;
    const lcpImageProps = {
      id: LCP_image.id,
      src: LCP_image.src,
      alt,
      onError: handleError,
      onClick: handleClick,
      onLoad: handleOnLoad,
      'data-test-id': testId,
      ...(isPdpHero && { 'data-pdp-hero': 'true' }),
      loading,
      ...(fetchPriority && { fetchpriority: fetchPriority }),
      ...(decoding && { decoding }),
      ...(lcpWidth && { width: lcpWidth }),
      ...(lcpHeight && { height: lcpHeight }),
      className,
      role:roleForImage || 'img',
      'aria-label': roleForImage == 'button' ? alt : '',
      'aria-haspopup' : opensDialog ? 'dialog' : ''
    };

    // Create a wrapper to attach event listeners
    return <img {...lcpImageProps} />;
  }

  return (
    <img
      src={replaceWithJioCDN(src)}
      loading={loading}
      {...(fetchPriority && { fetchpriority: fetchPriority })}
      {...(decoding && { decoding })}
      className={className}
      alt={alt}
      onError={handleError}
      onClick={handleClick}
      onLoad={handleOnLoad}
      data-test-id={testId}
      {...(isPdpHero && { 'data-pdp-hero': 'true' })}
      style={imgStyle}
      id={id}
      {...(roleForImage && { 'role': roleForImage })}
      aria-hidden={ariaHidden ? 'true' : undefined}
    />
  );
};

Image.defaultProps = {
  loading: 'auto'
};

export default Image;
